import getNavigator from './navigator';

const isTouchDevice = () => {
  const navigator = getNavigator();

  return 'ontouchstart' in window || navigator.msMaxTouchPoints;
};

export default isTouchDevice;
